export type StorageType = {
  setItem: (key: string, layout: number[]) => void;
  getItem: (key: string) => number[] | null;
};

const LOCAL_STORAGE_PANEL_RESIZE_KEY = 'databases-panel-resize-layout';

export const storage: StorageType = {
  setItem: (key: string, layout: number[]) => {
    localStorage.setItem(
      `${LOCAL_STORAGE_PANEL_RESIZE_KEY}-${key}`,
      JSON.stringify(layout)
    );
  },
  getItem: (key: string) => {
    const layout = localStorage.getItem(`${LOCAL_STORAGE_PANEL_RESIZE_KEY}-${key}`);
    return layout ? JSON.parse(layout) : null;
  },
};
